import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const POSTER = "https://images.unsplash.com/photo-1503803548695-c2a7b4a5b875?crop=entropy&cs=srgb&fm=jpg&q=80&w=1400";

export default function Login() {
  const { user, login } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const from = location.state?.from || "/trips";

  useEffect(() => { if (user) navigate(from, { replace: true }); }, [user, from, navigate]);

  return (
    <div className="min-h-[calc(100vh-74px)] grid md:grid-cols-2" data-testid="login-page">
      <div className="relative hidden md:block overflow-hidden grain">
        <video autoPlay muted loop playsInline poster={POSTER} className="absolute inset-0 w-full h-full object-cover">
          <source src="/media/ocean.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 hero-overlay" />
        <div className="absolute bottom-16 left-12 right-12">
          <div className="hairline mb-5" />
          <span className="overline">Rokert Retreats</span>
          <p className="font-heading text-5xl leading-tight mt-3 text-rr-ivory">Your private journey<br />awaits.</p>
        </div>
      </div>

      <div className="flex flex-col items-center justify-center px-8 py-16 bg-rr-bg">
        <div className="w-full max-w-sm text-center">
          <img src="/media/rokert-emblem.png" alt="Rokert Retreats" className="h-24 w-auto mx-auto" />
          <h1 className="font-heading text-5xl mt-6 mb-3 text-rr-ivory">Welcome</h1>
          <p className="text-rr-muted text-sm mb-10 leading-relaxed">Sign in to view your composed itineraries, secure your dates, and receive your enriched arrival details.</p>
          <button onClick={() => login(from)} data-testid="google-login-btn" className="w-full bg-rr-ivory text-rr-bg font-medium py-4 rounded-lg flex items-center justify-center gap-3 hover:bg-white transition-colors">
            <svg className="w-5 h-5" viewBox="0 0 24 24"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/></svg>
            Continue with Google
          </button>
          <p className="text-xs text-rr-muted/70 mt-6">We only need your name & email to begin. Further details are collected at confirmation.</p>
        </div>
      </div>
    </div>
  );
}
